<template>
    <v-card
        class="pb-7"
        :width="widthProp"
        elevation="0"
        style="border-radius: 10px"
    >
        <v-card-text class="pt-5 px-5">
            <v-form
                v-model="student_address_detail_status"
                ref="form"
                :disabled="disabledRules"
            >
                <v-row class="mt-1">
                    <v-col class="py-0 mb-4 ">
                        <div class="prompt-title">{{ $t("message.form.topics.homeRegistration") }}</div>
                        <span class="remark-text"> * {{ $t('message.common.remarkFillDash') }}</span>
                    </v-col>
                </v-row>
                <v-row >
                    <v-col cols="12" sm="6" md="6" class="py-0 my-1 pl-sm-2 pr-sm-2 pr-xs-3 pl-xs-3">
                        <div class="py-1 pt-0 form-label">
                            {{ from == "all" ? $t('message.form.addressData.address') : $t('message.form.topics.homeRegistration') }}
                            <strong>*</strong>
                        </div>
                        <v-text-field
                            dense
                            outlined
                            hide-details="auto"
                            v-bind:placeholder="$t('message.form.addressData.fillAddress')"
                            v-model="student_address_detail.national_address"
                            :rules="address_Rule"
                            v-on:change="sameAddress()"
                            required
                        >
                            <template #message="{ message }">
                                {{ $t(message) }}
                            </template>
                        </v-text-field>
                    </v-col>

                    <v-col cols="12" sm="6" md="6" class="py-0 my-1 pl-sm-2 pr-sm-2 pr-xs-3 pl-xs-3">
                        <div class="py-1 pt-0 form-label">
                            {{ $t('message.form.addressData.moo') }}
                            <strong>*</strong>
                        </div>
                        <v-text-field
                            dense
                            outlined
                            hide-details="auto"
                            v-bind:placeholder="$t('message.form.addressData.fillMoo')"
                            v-model="student_address_detail.national_moo"
                            :rules="moo_Rule"
                            v-on:change="sameAddress()"
                            required
                        >
                            <template #message="{ message }">
                                {{ $t(message) }}
                            </template>
                        </v-text-field>
                    </v-col>

                    <v-col cols="12" sm="6" md="6" class="py-0 my-1 pl-sm-2 pr-sm-2 pr-xs-3 pl-xs-3">
                        <div class="py-1 pt-0 form-label">
                            {{ $t('message.form.addressData.soi') }}
                            <strong>*</strong>
                        </div>
                        <v-text-field
                            dense
                            outlined
                            hide-details="auto"
                            v-bind:placeholder="$t('message.form.addressData.fillSoi')"
                            v-model="student_address_detail.national_soi"
                            :rules="soi_Rule"
                            v-on:change="sameAddress()"
                            required
                        >
                            <template #message="{ message }">
                                {{ $t(message) }}
                            </template>
                        </v-text-field>
                    </v-col>

                    <v-col cols="12" sm="6" md="6" class="py-0 my-1 pl-sm-2 pr-sm-2 pr-xs-3 pl-xs-3">
                        <div class="py-1 pt-0 form-label">
                            {{ $t('message.form.addressData.road') }}
                            <strong>*</strong>
                        </div>
                        <v-text-field
                            dense
                            outlined
                            hide-details="auto"
                            v-bind:placeholder="$t('message.form.addressData.fillRoad')"
                            v-model="student_address_detail.national_road"
                            :rules="road_Rule"
                            v-on:change="sameAddress()"
                            required
                        >
                            <template #message="{ message }">
                                {{ $t(message) }}
                            </template>
                        </v-text-field>
                    </v-col>

                    <v-col
                        cols="12"
                        sm="6"
                        :md="responsiveWithFrom"
                        class="py-0 my-1 pl-sm-2 pr-sm-2 pr-xs-3 pl-xs-3"
                    >
                        <div class="py-1 form-label">{{ $t("message.form.addressData.province") }} <strong>*</strong></div>
                        <v-select
                            dense
                            outlined
                            hide-details="auto"
                            v-bind:placeholder="$t('message.form.addressData.fillProvince')"
                            :items="provinces"
                            :item-text="locale == 'th' ? 'name_th' : 'name_en'"
                            item-value="value"
                            v-on:change="sameAddress()"
                            @change="onChangeProvince(student_address_detail?.national_province, false)"
                            v-model="student_address_detail.national_province"
                            :rules="province_Rule"
                        >
                            <template #message="{ message }">
                                {{ $t(message) }}
                            </template>
                        </v-select>
                    </v-col>

                    <v-col
                        cols="12"
                        sm="6"
                        :md="responsiveWithFrom"
                        class="py-0 my-1 pl-sm-2 pr-sm-2 pr-xs-3 pl-xs-3"
                    >
                        <div class="py-1 form-label">{{ $t("message.form.addressData.district") }} <strong>*</strong></div>
                        <v-select
                            :disabled="
                                student_address_detail?.national_province
                                    .length == 0
                            "
                            dense
                            outlined
                            hide-details="auto"
                            v-bind:placeholder="$t('message.form.addressData.fillDistrict')"
                            :items="national_districts"
                            :item-text="locale == 'th' ? 'name_th' : 'name_en'"
                            item-value="value"
                            v-on:change="sameAddress()"
                            @change="onChangeDistrict(student_address_detail?.national_district, false)"
                            v-model="student_address_detail.national_district"
                            :rules="district_Rule"
                        >
                            <template #message="{ message }">
                                {{ $t(message) }}
                            </template>
                        </v-select>
                    </v-col>

                    <v-col
                        cols="12"
                        sm="6"
                        :md="responsiveWithFrom"
                        class="py-0 my-1 pl-sm-2 pr-sm-2 pr-xs-3 pl-xs-3"
                    >
                        <div class="py-1 form-label">{{ $t("message.form.addressData.subdistrict") }} <strong>*</strong></div>
                        <v-select
                            :disabled="
                                student_address_detail?.national_district
                                    .length == 0
                            "
                            dense
                            outlined
                            hide-details="auto"
                            v-bind:placeholder="$t('message.form.addressData.fillSubdistrict')"
                            v-on:change="sameAddress()"
                            :items="national_subdistricts"
                            :item-text="locale == 'th' ? 'name_th' : 'name_en'"
                            item-value="value"
                            v-model="student_address_detail.national_subdistrict"
                            :rules="subdistrict_Rule"
                        >
                            <template #message="{ message }">
                                {{ $t(message) }}
                            </template>
                        </v-select>
                    </v-col>

                    <v-col
                        cols="12"
                        sm="6"
                        :md="responsiveWithFrom"
                        class="py-0 my-1 pl-sm-2 pr-sm-2 pr-xs-3 pl-xs-3"
                    >
                        <div class="py-1 form-label">{{ $t("message.form.addressData.postalCode") }} <strong>*</strong></div>
                        <v-text-field
                            dense
                            outlined
                            hide-details="auto"
                            v-bind:placeholder="$t('message.form.addressData.fillPostalCode')"
                            v-on:change="sameAddress()"
                            v-mask="'#########'"
                            v-model="student_address_detail.national_postal_code"
                            :rules="postal_Rule"
                        >
                            <template #message="{ message }">
                                {{ $t(message) }}
                            </template>
                        </v-text-field>
                    </v-col>
                </v-row>
                <!--step5-->

                <div v-if="this.stepActive == 5 || showSectionCondition">
                    <v-divider class="mt-10 mb-1"></v-divider>
                    <v-row>
                        <v-col cols="12" md="8">
                            <div class="mt-3 mr-0 pa-1 prompt-title">{{ $t("message.form.topics.presentAddress") }}</div>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-checkbox
                                :label= "$t('message.form.addressData.useHomeRegis')"
                                color="orange"
                                hide-details="auto"
                                v-on:change="sameAddress()"
                                v-model="student_address_detail.is_same_address"
                                class="mt-2"
                            ></v-checkbox>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="6" md="12" class="py-0 my-1">
                            <div class="py-1 form-label">{{ $t('message.form.addressData.address')}} <strong>*</strong></div>
                            <v-text-field
                                dense
                                outlined
                                hide-details="auto"
                                v-bind:placeholder="$t('message.form.addressData.fillAddress')"
                                v-model="student_address_detail.current_address"
                                :rules="address_Rule"
                                :disabled="student_address_detail?.is_same_address"
                                required
                            >
                                <template #message="{ message }">
                                    {{ $t(message) }}
                                </template>
                            </v-text-field>
                        </v-col>

                        <v-col cols="12" sm="6" md="12" class="py-0 my-1 pr-sm-2 pr-md-3 pr-xs-3">
                            <div class="py-1 pt-0 form-label">
                                {{ $t('message.form.addressData.moo') }}
                                <strong>*</strong>
                            </div>
                            <v-text-field
                                dense
                                outlined
                                hide-details="auto"
                                v-bind:placeholder="$t('message.form.addressData.fillMoo')"
                                v-model="student_address_detail.current_moo"
                                :rules="moo_Rule"
                                :disabled="student_address_detail?.is_same_address"
                                required
                            >
                                <template #message="{ message }">
                                    {{ $t(message) }}
                                </template>
                            </v-text-field>
                        </v-col>

                        <v-col cols="12" sm="6" md="12" class="py-0 my-1 pr-sm-2 pr-md-3 pr-xs-3">
                            <div class="py-1 pt-0 form-label">
                                {{ $t('message.form.addressData.soi') }}
                                <strong>*</strong>
                            </div>
                            <v-text-field
                                dense
                                outlined
                                hide-details="auto"
                                v-bind:placeholder="$t('message.form.addressData.fillSoi')"
                                v-model="student_address_detail.current_soi"
                                :rules="soi_Rule"
                                :disabled="student_address_detail?.is_same_address"
                                required
                            >
                                <template #message="{ message }">
                                    {{ $t(message) }}
                                </template>
                            </v-text-field>
                        </v-col>

                        <v-col cols="12" sm="6" md="12" class="py-0 my-1 pr-sm-2 pr-md-3 pr-xs-3">
                            <div class="py-1 pt-0 form-label">
                                {{ $t('message.form.addressData.road') }}
                                <strong>*</strong>
                            </div>
                            <v-text-field
                                dense
                                outlined
                                hide-details="auto"
                                v-bind:placeholder="$t('message.form.addressData.fillRoad')"
                                v-model="student_address_detail.current_road"
                                :rules="road_Rule"
                                :disabled="student_address_detail?.is_same_address"
                                required
                            >
                                <template #message="{ message }">
                                    {{ $t(message) }}
                                </template>
                            </v-text-field>
                        </v-col>

                        <v-col
                            cols="12"
                            sm="6"
                            :md="responsiveWithFrom"
                            class="py-0 my-1"
                        >
                            <div class="py-1 form-label">{{ $t("message.form.addressData.province") }} <strong>*</strong></div>
                            <v-select
                                dense
                                outlined
                                hide-details="auto"
                                v-bind:placeholder="$t('message.form.addressData.fillProvince')"
                                :items="provinces"
                                :item-text="locale == 'th' ? 'name_th' : 'name_en'"
                                item-value="value"
                                @change="
                                    onChangeProvince(
                                        student_address_detail?.current_province,
                                        true
                                    )
                                "
                                v-model="
                                    student_address_detail.current_province
                                "
                                :rules="province_Rule"
                                :disabled="
                                    student_address_detail?.is_same_address
                                "
                            >
                                <template #message="{ message }">
                                    {{ $t(message) }}
                                </template>
                            </v-select>
                        </v-col>

                        <v-col
                            cols="12"
                            sm="6"
                            :md="responsiveWithFrom"
                            class="py-0 my-1"
                        >
                            <div class="py-1 form-label">{{ $t("message.form.addressData.district") }} <strong>*</strong></div>
                            <v-select
                                dense
                                outlined
                                hide-details="auto"
                                v-bind:placeholder="$t('message.form.addressData.fillDistrict')"
                                :items="current_districts"
                                :item-text="locale == 'th' ? 'name_th' : 'name_en'"
                                item-value="value"
                                @change="
                                    onChangeDistrict(
                                        student_address_detail?.current_district,
                                        true
                                    )
                                "
                                v-model="
                                    student_address_detail.current_district
                                "
                                :rules="district_Rule"
                                :disabled="
                                    student_address_detail?.is_same_address ||
                                    student_address_detail?.current_province
                                        .length == 0
                                "
                            >
                                <template #message="{ message }">
                                    {{ $t(message) }}
                                </template>
                            </v-select>
                        </v-col>

                        <v-col
                            cols="12"
                            sm="6"
                            :md="responsiveWithFrom"
                            class="py-0 my-1"
                        >
                            <div class="py-1 form-label">{{ $t("message.form.addressData.subdistrict") }} <strong>*</strong></div>
                            <v-select
                                dense
                                outlined
                                hide-details="auto"
                                v-bind:placeholder="$t('message.form.addressData.fillSubdistrict')"
                                :items="current_subdistricts"
                                :item-text="locale == 'th' ? 'name_th' : 'name_en'"
                                item-value="value"
                                v-model="
                                    student_address_detail.current_subdistrict
                                "
                                :rules="subdistrict_Rule"
                                :disabled="
                                    student_address_detail?.is_same_address ||
                                    student_address_detail?.current_district == 0
                                "
                            >
                            <template #message="{ message }">
                                {{ $t(message) }}
                            </template></v-select>
                        </v-col>

                        <v-col
                            cols="12"
                            sm="6"
                            :md="responsiveWithFrom"
                            class="py-0 my-1"
                        >
                            <div class="py-1 form-label">{{ $t("message.form.addressData.postalCode") }} <strong>*</strong></div>
                            <v-text-field
                                dense
                                outlined
                                hide-details="auto"
                                v-bind:placeholder="$t('message.form.addressData.fillPostalCode')"
                                v-model="
                                    student_address_detail.current_postal_code
                                "
                                v-mask="'#########'"
                                :rules="postal_Rule"
                                :disabled="
                                    student_address_detail?.is_same_address
                                "
                            >
                            <template #message="{ message }">
                                {{ $t(message) }}
                            </template></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="12" class="py-0 my-1">
                            <div class="py-1 form-label">{{$t('message.form.addressData.addressType')}} <strong>*</strong></div>
                            <v-radio-group
                                row
                                class="py-0 mt-2"
                                hide-details="auto"
                                v-model="
                                    student_address_detail.accommodation_type
                                "
                                required
                                :rules="[(v) => !!v || 'message.form.addressData.fillAddressType']"
                            >
                            <template #message="{ message }">
                                {{ $t(message) }}
                            </template>
                                <v-row class="mt-1">
                                    <v-col
                                        cols="12"
                                        sm="6"
                                        md="4"
                                        class="pt-0"
                                        v-for="item in accommodationTypes"
                                        :key="item.value"
                                    >
                                        <v-radio
                                            v-bind:label="$t(item.text)"
                                            :value="item.value"
                                            color="orange"
                                        ></v-radio>
                                    </v-col>
                                    <template #message="{ message }">
                                        {{ $t(message) }}
                                    </template>
                                </v-row>
                            </v-radio-group>
                        </v-col>
                        <v-col cols="12" sm="6" md="6" class="py-1 my-1">
                            <div class="py-1 form-label">
                                {{$t('message.form.addressData.distance')}} <strong>*</strong>
                            </div>
                            <v-text-field
                                dense
                                outlined
                                hide-details="auto"
                                placeholder="0"
                                v-model="
                                    student_address_detail.distance_home_to_school
                                "
                                :suffix= 'km'
                                v-mask="'#####'"
                                :rules="[
                                    (v) => !!v || 'message.form.addressData.fillDistance',
                                    (v) => /^[0-9]*$/.test(v) || 'message.form.addressData.invalidDistance',
                                ]"
                            >
                            <template #message="{ message }">
                  {{ $t(message) }}
                </template></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="12" class="py-0 my-1">
                            <div class="py-1 form-label">
                                {{$t('message.form.addressData.transport')}} <strong>*</strong>
                            </div>
                            <v-radio-group
                                row
                                class="py-0 mt-2"
                                hide-details="auto"
                                v-model="
                                    student_address_detail.transportation_type
                                "
                                :rules="[(v) => !!v || 'message.form.addressData.fillTransport']"
                                required
                            >
                            <template #message="{ message }">
                                {{ $t(message) }}
                            </template>
                                <v-row class="mt-1">
                                    <v-col
                                        cols="12"
                                        sm="6"
                                        md="4"
                                        class="pt-0"
                                        v-for="item in transportationTypes"
                                        :key="item.value"
                                    >
                                        <v-radio
                                            v-bind:label="$t(item.text)"
                                            :value="item.value"
                                            color="orange"
                                        ></v-radio>
                                    </v-col>
                                </v-row>
                            </v-radio-group>
                        </v-col>
                    </v-row>
                </div>
            </v-form>
        </v-card-text>
    </v-card>
</template>

<script>
import { ACCOMMODATION_TYPE, TRANSPORTATION_TYPE } from "@/constants";
import i18n from "@/i18n"
export default {
    name: "StudentAddress",
    data: () => ({
        student_address_detail_status: false,
        student_address_detail: {
            national_address: "",
            national_moo: "",
            national_soi: "",
            national_road: "",
            national_province: "",
            national_district: "",
            national_subdistrict: "",
            national_postal_code: "",
            is_same_address: false,
            current_address: "",
            current_moo: "",
            current_soi: "",
            current_road: "",
            current_province: "",
            current_district: "",
            current_subdistrict: "",
            current_postal_code: "",
            accommodation_type: "",
            distance_home_to_school: "",
            transportation_type: 0,
        },
        provinces: [],
        national_districts: [],
        national_subdistricts: [],
        current_districts: [],
        current_subdistricts: [],

        transportationTypes: TRANSPORTATION_TYPE,
        accommodationTypes: ACCOMMODATION_TYPE,

        address_Rule: [
            (v) => !!v || 'message.form.addressData.fillAddress',
        ],
        moo_Rule: [
            (v) => !!v || 'message.form.addressData.fillMoo',
        ],
        soi_Rule: [
            (v) => !!v || 'message.form.addressData.fillSoi',
        ],
        road_Rule: [
            (v) => !!v || 'message.form.addressData.fillRoad',
        ],
        province_Rule: [(v) => !!v || "message.form.addressData.invalidProvince"],
        district_Rule: [(v) => !!v || "message.form.addressData.invalidDistrict"],
        subdistrict_Rule: [(v) => !!v || "message.form.addressData.invalidSubdistrict"],
        postal_Rule: [(v) => !!v || "message.form.addressData.fillPostalCode"],
        km: i18n.t('message.form.addressData.km')
    }),
    methods: {
        onChangeProvince: async function (value, isCurrent) {
            try {
                this.$emit("loadingUpdate", 1);
                var data = await getDistrict(value);
                if (isCurrent) {
                    this.current_districts = data.district;
                    this.student_address_detail.current_district = "";
                    this.student_address_detail.current_subdistrict = "";
                } else {
                    this.national_districts = data.district;
                    this.student_address_detail.national_district = "";
                    this.student_address_detail.national_subdistrict = "";
                }
            } finally{
                this.$emit("loadingUpdate", -1);
            }
        },
        onChangeDistrict: async function (value, isCurrent) {
            try {
                this.$emit("loadingUpdate", 1);
                var data = await getSubdistrict(value);
                if (isCurrent) {
                    this.current_subdistricts = data.subdistrict;
                    this.student_address_detail.current_subdistrict = "";
                } else {
                    this.national_subdistricts = data.subdistrict;
                    this.student_address_detail.national_subdistrict = "";
                }
            } finally{
                this.$emit("loadingUpdate", -1);
            }
        },
        validate() {
            this.$refs.form.validate();
        },
        sameAddress() {
            if (this.student_address_detail?.is_same_address) {
                this.student_address_detail.current_address =
                    this.student_address_detail?.national_address;
                this.student_address_detail.current_moo =
                    this.student_address_detail?.national_moo;
                this.student_address_detail.current_soi =
                    this.student_address_detail?.national_soi;
                this.student_address_detail.current_road =
                    this.student_address_detail?.national_road;
                this.student_address_detail.current_province =
                    this.student_address_detail?.national_province;
                this.current_districts = this.national_districts;
                this.student_address_detail.current_district =
                    this.student_address_detail?.national_district;
                this.current_subdistricts = this.national_subdistricts;
                this.student_address_detail.current_subdistrict =
                    this.student_address_detail?.national_subdistrict;
                this.student_address_detail.current_postal_code =
                    this.student_address_detail?.national_postal_code;
            }
        },
        async fetchInitData() {
            try {
                this.$emit("loadingUpdate", 1);
                let data = await getProvince();

                data.province.map((item) => {
                    this.provinces.push(item);
                });
                if (this.stepActive == 5 || this.from == "candidates"){
                    await this.fetchInitStudentQuery();
                }
            } finally{
                this.$emit("loadingUpdate", -1);
            }
        },
        onChangeData() {
            this.$emit("formValidate", this.$refs?.form?.value);
        },
        async fetchInitStudentQuery() {
            try {
                this.$emit("loadingUpdate", 1);
                const body = {
                    query: {
                        selects: {
                            id: true,
                            student_address_detail: {
                                national_address: true,
                                national_moo: true,
                                national_soi: true,
                                national_road: true,
                                national_postal_code: true,
                                national_province: true,
                                national_district: true,
                                national_subdistrict: true,
                            },
                        },
                        relations: {
                            student_address_detail: {
                                national_province: true,
                                national_district: true,
                                national_subdistrict: true,
                            },
                        },
                    },
                };
                if (this.from == "candidates") {
                    body["id"] = this.applicantId;
                    if (this.stepActive == 5) {
                        body.query.selects.student_address_detail = {
                            ...body.query.selects.student_address_detail,
                            accommodation_type: true,
                            current_address: true,
                            current_moo: true,
                            current_soi: true,
                            current_road: true,
                            current_postal_code: true,
                            current_province: true,
                            current_district: true,
                            current_subdistrict: true,
                            distance_home_to_school: true,
                            is_same_address: true,
                            transportation_type: true
                        };
                        body.query.relations.student_address_detail = {
                            ...body.query.relations.student_address_detail,
                            current_province: true,
                            current_district: true,
                            current_subdistrict: true,
                        };
                    }
                } else if (this.stepActive == 5) {
                    body["token"] = localStorage.getItem("token");
                }

                const {
                    data: { data },
                } = await services.getStudentWithQuery(body);

                this.autoFillDataFromDb(data?.student?.student_address_detail);
            } finally{
                this.$emit("loadingUpdate", -1);
            }
        },
        async autoFillDataFromDb(data) {
            try{
                this.$emit("loadingUpdate", 1);
                Object.keys(data).forEach(async (key) => {
                    if (
                        !(
                            key == "national_province" ||
                            key == "national_district" ||
                            key == "national_subdistrict" ||
                            key == "current_province" ||
                            key == "current_district" ||
                            key == "current_subdistrict"
                        )
                    ) {
                        this.student_address_detail[key] = data?.[key];
                    }
                });
                this.student_address_detail["national_province"] =
                    data?.["national_province"]?.value;
                await this.onChangeProvince(data?.["national_province"]?.value, false);
                this.student_address_detail["national_district"] =
                    data?.["national_district"]?.value;
                await this.onChangeDistrict(data?.["national_district"]?.value, false);
                this.student_address_detail["national_subdistrict"] =
                    data?.["national_subdistrict"]?.value;
                if(this.from == "candidates"){
                    this.student_address_detail["current_province"] =
                        data?.["national_province"]?.value;
                    await this.onChangeProvince(data?.["current_province"]?.value, true);
                    this.student_address_detail["current_district"] =
                        data?.["current_district"]?.value;
                    await this.onChangeDistrict(data?.["current_district"]?.value, true);
                    this.student_address_detail["current_subdistrict"] =
                        data?.["current_subdistrict"]?.value;
                }
            } finally{
                this.$emit("loadingUpdate", -1);
            }
        },
    },
    props: {
        checkValidate: Boolean,
        callAutoFill: Boolean,
        stepActive: Number,
        applicantId: Number,
        widthProp: {
            default: "690",
            type: String,
        },
        registrationState: {
            default: "all",
            type: String,
        },
        from: {
            default: "all",
            type: String,
        },
    },
    emits: ["formValidate"],
    computed: {
        locale(){
            return i18n.locale
        },
        disabledRules() {
            if (this.stepActive == 5 && this.$route.query?.action == "view")
                return true;
            return false;
        },
        showSectionCondition() {
            try {
                let allow_state = [
                    "SUCCESSFUL_CONFIRMATION_DETAIL",
                    "SUCCESSFUL_ENROLLMENT",
                ];
                if (this.from == "all") return false;
                if (
                    this.from == "candidates" &&
                    allow_state.includes(this.registrationState)
                )
                    return true;
                return false;
            } catch (error) {
                return false;
            }
        },

        responsiveWithFrom() {
            if (this.from == "candidates") return 3;
            return 6;
        },
    },
    watch: {
        checkValidate: function () {
            this.validate();
        },
        callAutoFill: function () {
            this.autoFill();
        },
    },
    mounted() {
        this.fetchInitData();
    },
    updated() {
        this.onChangeData();
    },
};

import * as services from "../../services";
const getProvince = async () => {
    const {
        data: { data },
    } = await services.getProvince();
    return data;
};

const getDistrict = async (province) => {
    const {
        data: { data },
    } = await services.getDistrictByProvince(province);
    return data;
};

const getSubdistrict = async (district) => {
    const {
        data: { data },
    } = await services.getSubdistrictByProvince(district);
    return data;
};
</script>

<style scoped>
.form-label{
    font-size: 18px;
}
.remark-text {
    font-weight: 400;
    font-size: 16px;
    color: red;
}
</style>
